export const DATE_COLUMN_WIDTH = '8.4rem';
export const ARTICLE_TYPE_COLUMN_WIDTH = '8rem';
export const CONTEXT_MENU_COLUMN_WIDTH = '3.2rem';
export const TICKER_COLUMN_WIDTH = '12rem';
export const COVERAGE_COLUMN_WIDTH = '11.6rem';
